import qs from 'querystringify'
import remote from './remote'

const URL = {
    ADD: '/cms/announce',
    SEARCH: '/cms/announce',
    DELETE: '/cms/announce',
    UPDATE: '/cms/announce'
}

export default {
    notiAdd (noti, uploadProgressHandler) {
        return remote.request({
          url: remote.getUrl(URL.ADD),
          method: remote.METHOD.POST,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          data: noti,
          timeout: 3600000,
          onUploadProgress: uploadProgressHandler,
        });
    },
    updateNoti (contentId, noti, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.UPDATE) + '/' + contentId,
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: noti,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    searchNoti (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url
        })
    },
    searchNotiDetail (contentId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + contentId,
            timeout: 30000,
        })
    },
    removeNoti (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
